export enum TileType {
  RESTAURANT = 'RESTAURANT',
  SHARE = 'SHARE',
  ADD_RESTAURANT = 'ADD_RESTAURANT',
  DIVIDER = 'DIVIDER',
}
